<template>
<div class="main_content">
  <div class="center">
    <img class="tip_img" :src="curItem.img" :alt="curItem.alt">
    <div>{{curItem.text}}</div>
  </div>
</div>
</template>

<script>
  export default {
    props: ['curItem']
  }
</script>

<style lang="scss" scoped>
.main_content {
  background: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .center {
    font-size: 16px;
    text-align: center;
    width: 300px;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin: 0 auto;
  }
  .tip_img {
    width: 93px;
    height: 75px;
    margin-bottom: 6px;
  }
}
</style>
